import { gql } from '@apollo/client'

export const CREATE_TRANSMISSION = gql`
  mutation createTransmission($input: CreateTransmissionInput!) {
    data: createTransmission(input: $input) {
      id
    }
  }
`
